import { useMutation } from '@apollo/client';
import { submitServiceRequestFeedbackMutation } from 'graphql-queries';
import { ServiceRequestFeedbackError } from '../../../errors/ServiceRequestFeedbackError';

export type ServiceRequestFeedback = {
  serviceRequestId: string;
  rating: number;
  comment?: string;
};

export const useSubmitServiceRequestFeedback = () => {
  const [submitFeedbackMutation, { loading, error }] = useMutation(
    submitServiceRequestFeedbackMutation
  );

  const submitFeedback = async (
    feedback: ServiceRequestFeedback
  ): Promise<boolean> => {
    const result = await submitFeedbackMutation({
      variables: { feedback },
    });

    return result.data?.submitServiceRequestFeedback.success || false;
  };

  return {
    submitFeedback,
    loading,
    error: error
      ? new ServiceRequestFeedbackError(
          error instanceof Error ? error.message : 'An error occurred'
        )
      : undefined,
  };
};
